import { useTranslation as i18nUseTranslation, UseTranslationResponse } from "react-i18next";

export const useTranslation = (namespace?: string): UseTranslationResponse<string> => {
  const defaultTranslation = i18nUseTranslation(namespace || "translation");

  return defaultTranslation;
};
